import { render, staticRenderFns } from "./btnBasic.vue?vue&type=template&id=6ee0d0b4"
import script from "./btnBasic.vue?vue&type=script&lang=js"
export * from "./btnBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports